import React, { useEffect } from "react";
import "./PreferredDatesSelector.css";
import { useModerationWindowDates } from "../../context/ModerationWindowDatesContext";
import { formatDate, useModerationWindowSession } from "../../constants/Constants";

const PreferredDatesSelector = ({
  selectedDates = [],
  onChange,
  moderationWindow = "window1",
  showErrors = false,
  sessionId,
}) => {
   const moderationWindowSession = useModerationWindowSession();
 
  const { datesCache, fetchPreferredDates } = useModerationWindowDates();
  useEffect(() => {
    // Only fetch if not already loaded!
    if (sessionId) fetchPreferredDates(sessionId);
  }, [sessionId, fetchPreferredDates]);

  const window1Dates =
    datesCache[moderationWindowSession["window1"]]?.dates || [];
  const window2Dates =
    datesCache[moderationWindowSession["window2"]]?.dates || [];
  const availableDates =
    moderationWindow === "window1" ? window1Dates : window2Dates;

  const handleDateChange = (date) => {
    const newSelection = selectedDates.includes(date)
      ? selectedDates.filter((d) => d !== date)
      : [...selectedDates, date];
    onChange && onChange(newSelection);
  };

  const hasError = showErrors && !selectedDates.length;
  return (
    <div
      className={`preferred-dates-selector ${
        hasError ? "field-validation has-error" : ""
      }`}
    >
      <label className="label">
        Select your preferred dates for this visit{" "}
        <span className="has-text-danger">*</span>
      </label>

      <p className="input-help-text">You must select at least one</p>

      <p className="py-2">Week beginning:</p>

      <ul className="dates-list">
        {availableDates.map((date) => (
          <li>
            <label
              key={date}
              className={`checkbox is-block mb-1 ${
                hasError ? "has-error" : ""
              }`}
            >
              <input
                type="checkbox"
                checked={selectedDates.includes(date)}
                onChange={() => handleDateChange(date)}
                className="mr-2"
              />
              {formatDate(date)}
            </label>
          </li>
        ))}
      </ul>

      {hasError && (
        <div className="error-message">
          You must select at least one preferred week
        </div>
      )}
    </div>
  );
};

export default PreferredDatesSelector;
